module.exports = __webpack_public_path__ + "img/recon_active.4800fafd.svg";